// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-csat-rating-current {
    display: flex;
    align-items: center;
    background: #FFFAF5;
    box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000D;
}

.BC-csat-rating-current .rating-form {
    padding: 16px;
    flex-grow: 1;
    min-height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.BC-csat-rating-current .rating-form .title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 600;
}

.BC-csat-rating-current .rating-form .subtitle {
    margin-bottom: 8px;
}

.BC-csat-rating-current .rating-form .star-container {
    display: flex;
    align-items: center;
    gap: 7.5px;
}

.BC-csat-rating-current .rating-form .star-container .rating-star {
    cursor: pointer;
    width: 32px;
    height: 32px;
}

.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--hover path {
    fill: #F9B23A;
    opacity: 1;
}

.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--selected path {
    fill: #F9B23A;
    opacity: 1;
}

.BC-csat-rating-current .rating-img {
    width: 218px;
    height: 126px;
    object-fit: cover;
    flex-shrink: 0;
}

.BC-csat-rating-current .rating-img.rating-img--large {
    height: 134px;
}

.BC-csat-rating-current .Feedback__Action {
    margin-top: 12px;
    display: flex;
    gap: 8px;
}

/* Onboarding */

.BC-Page.BC-Page__DashboardV3 .ob-rating-container {
    display: flex;
    align-items: center;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form {
    padding: 16px;
    flex-grow: 1;
    min-height: 103px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}


.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 600;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .subtitle {
    margin-bottom: 8px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container {
    display: flex;
    align-items: center;
    gap: 7.5px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star {
    cursor: pointer;
    width: 32px;
    height: 32px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star path {
    fill: #003D2C;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star.rating-star--hover path {
    fill: #F9B23A;
    opacity: 1;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star.rating-star--selected path {
    fill: #F9B23A;
    opacity: 1;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-img {
    width: 160px;
    height: 103px;
    object-fit: cover;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .Feedback__Action {
    margin-top: 12px;
    display: flex;
    gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;AACZ;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;AACZ","sourcesContent":[".BC-csat-rating-current {\n    display: flex;\n    align-items: center;\n    background: #FFFAF5;\n    box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000D;\n}\n\n.BC-csat-rating-current .rating-form {\n    padding: 16px;\n    flex-grow: 1;\n    min-height: 130px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n\n.BC-csat-rating-current .rating-form .title {\n    margin-bottom: 4px;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.BC-csat-rating-current .rating-form .subtitle {\n    margin-bottom: 8px;\n}\n\n.BC-csat-rating-current .rating-form .star-container {\n    display: flex;\n    align-items: center;\n    gap: 7.5px;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star {\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--hover path {\n    fill: #F9B23A;\n    opacity: 1;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--selected path {\n    fill: #F9B23A;\n    opacity: 1;\n}\n\n.BC-csat-rating-current .rating-img {\n    width: 218px;\n    height: 126px;\n    object-fit: cover;\n    flex-shrink: 0;\n}\n\n.BC-csat-rating-current .rating-img.rating-img--large {\n    height: 134px;\n}\n\n.BC-csat-rating-current .Feedback__Action {\n    margin-top: 12px;\n    display: flex;\n    gap: 8px;\n}\n\n/* Onboarding */\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container {\n    display: flex;\n    align-items: center;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form {\n    padding: 16px;\n    flex-grow: 1;\n    min-height: 103px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .title {\n    margin-bottom: 4px;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .subtitle {\n    margin-bottom: 8px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container {\n    display: flex;\n    align-items: center;\n    gap: 7.5px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star {\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star path {\n    fill: #003D2C;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star.rating-star--hover path {\n    fill: #F9B23A;\n    opacity: 1;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star.rating-star--selected path {\n    fill: #F9B23A;\n    opacity: 1;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-img {\n    width: 160px;\n    height: 103px;\n    object-fit: cover;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .Feedback__Action {\n    margin-top: 12px;\n    display: flex;\n    gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
